import { Card } from '@/common/ui/Card/Card'
import { cn } from '@/common/lib/cn/cn'
import type { CommonProductScoresSchema } from '@/common/api/client/types.gen'
import { formatCatalogPercent, formatScoreValue } from '../lib/scoreColors'

type CompanyStatsSummaryCardsProps = {
    data: CommonProductScoresSchema
}

type SummaryCardProps = {
    label: string
    value: string
    subtext?: string
    valueClassName?: string
}

const SummaryCard = ({ label, value, subtext, valueClassName = 'text-white' }: SummaryCardProps) => (
    <Card color='primary' className='flex-1 min-w-[140px]'>
        <p className='text-xs font-bold uppercase tracking-wide text-white mb-2'>{label}</p>
        <p className={cn('text-3xl font-semibold leading-none', valueClassName)}>{value}</p>
        {subtext ? <p className='text-sm text-base-content/60 mt-2'>{subtext}</p> : null}
    </Card>
)

export const CompanyStatsSummaryCards = ({ data }: CompanyStatsSummaryCardsProps) => (
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4'>
        <SummaryCard
            label='Средний балл'
            value={formatScoreValue(data.avg_score)}
            subtext='из 10.0'
            valueClassName='text-[#08AC81]'
        />
        <SummaryCard label='Всего товаров' value={String(data.total_products)} />
        <SummaryCard
            label='Хорошие (8–9)'
            value={String(data.best?.count ?? 0)}
            subtext={formatCatalogPercent(data.best?.percents)}
            valueClassName='text-[#08AC81]'
        />
        <SummaryCard
            label='Средние (6–7)'
            value={String(data.middle?.count ?? 0)}
            subtext={formatCatalogPercent(data.middle?.percents)}
            valueClassName='text-[#F59E0B]'
        />
        <SummaryCard
            label='Слабые (≤5)'
            value={String(data.low?.count ?? 0)}
            subtext={formatCatalogPercent(data.low?.percents)}
            valueClassName='text-[#FF484B]'
        />
    </div>
)
